import React from 'react';

type RatingStarsProps = {
  rating: number;
  total?: number;
  link?: string;
  hideRating?: boolean;
  additionalClasses?: string;
};

function RatingStars({
  rating,
  total,
  link,
  hideRating,
  additionalClasses
}: RatingStarsProps) {
  const stars = Array.from(Array(5).keys());

  const addTrailingZero = (number: number) => {
    const numberString = number.toString();

    if (numberString.indexOf('.') === -1) {
      return numberString + '.0';
    } else {
      return numberString;
    }
  };

  return (
    <div
      className={`rating-stars ${additionalClasses}`}
      data-module="rating-stars"
      data-rating="4.9"
    >
      <div className="rating-stars__stars">
        {stars.map(i => {
          const starValue = Number((rating - i).toFixed(2));

          if (starValue >= 0.8) {
            return (
              <div key={i} className="rating-star rating-star--filled"></div>
            );
          }

          if (starValue >= 0.3) {
            return (
              <div
                key={i}
                className="rating-star rating-star--half-filled"
              ></div>
            );
          }

          return <div key={i} className="rating-star"></div>;
        })}
      </div>
      {!hideRating && (
        <span className="rating-stars__average">{addTrailingZero(rating)}</span>
      )}
      {total && <span className="rating-stars__total">({total})</span>}
      {link && (
        <a
          href="#unique-contractor-reviews-id"
          rel="noopener noreferrer"
          className="rating-stars__link"
          data-layer='[{"event":"view_reviews_click","event_action":"view reviews click","event_label":"","event_attributes":{"contractor_id":null,"contractor_name":null,"contractor_certificates_count":0,"contractor_rating":0,"contractor_reviews_count":0,"contractor_type":null,"contractor_certificate_name":null},"event_category":"contractor interactions"}]'
        >
          <span className="sr-only">See reviews</span>
        </a>
      )}
    </div>
  );
}

export default RatingStars;
